var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20002 2.2001C1.20002 1.31644 1.91637 0.600098 2.80002 0.600098H6.46865C6.893 0.600098 7.29997 0.768669 7.60002 1.06873L10.3314 3.8001C10.6315 4.10016 10.8 4.50712 10.8 4.93147V11.8001C10.8 12.6838 10.0837 13.4001 9.20002 13.4001H7.97779C8.73786 12.5509 9.20002 11.4295 9.20002 10.2001C9.20002 7.54913 7.05099 5.4001 4.40002 5.4001C3.17066 5.4001 2.04923 5.86226 1.20002 6.62233V2.2001Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40002 7.0001C2.63271 7.0001 1.20002 8.43279 1.20002 10.2001C1.20002 10.7932 1.36186 11.3492 1.6432 11.8256L0.634339 12.8344C0.32192 13.1468 0.32192 13.6534 0.634339 13.9658C0.946758 14.2782 1.45329 14.2782 1.76571 13.9658L2.77457 12.9569C3.25092 13.2383 3.80692 13.4001 4.40002 13.4001C6.16734 13.4001 7.60002 11.9674 7.60002 10.2001C7.60002 8.43279 6.16734 7.0001 4.40002 7.0001ZM2.80002 10.2001C2.80002 9.31644 3.51637 8.6001 4.40002 8.6001C5.28368 8.6001 6.00002 9.31644 6.00002 10.2001C6.00002 11.0838 5.28368 11.8001 4.40002 11.8001C3.95798 11.8001 3.55907 11.6219 3.26865 11.3315C2.97823 11.041 2.80002 10.6421 2.80002 10.2001Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearch);
export default __webpack_public_path__ + "static/media/document-search.3bc73288e98ae28cb9682eea6c1e3bb8.svg";
export { ForwardRef as ReactComponent };